const $ = require('jquery');

export default {
  init() {
    const ilnToggler = document.getElementById('show-all-iln');
    const ilnContainer: HTMLElement = document.querySelector('.iln__body-wrap');

    if (ilnContainer && ilnToggler) {
      ilnToggler.addEventListener('click', () => {
        ilnContainer.style.maxHeight = `${ilnContainer.scrollHeight}px`;
        ilnContainer.classList.add('full-height');
        $(ilnToggler).fadeOut('fast');
      });
    }
  }
};
